import { RegisterUserPostRequestModel, ActivateUserPostRequestModel } from "@/features/user/services/user-model";
import { RegisterUserApi } from "@/features/user/services/register-user-api";
import { ActivateUserApi } from "@/features/user/services/activate-user-api";

// 利用者登録画面処理
export class SignUpService {
  private registerUserApi = new RegisterUserApi();
  private activateUserApi = new ActivateUserApi();

  /**
   * 利用者仮登録API実行
   */
  public async register(param: RegisterUserPostRequestModel) {
    return await this.registerUserApi.postRegisterUser(param);
  }

  /**
   * 利用者本登録API実行
   */
  public async activate(param: ActivateUserPostRequestModel) {
    return await this.activateUserApi.postActivateUser(param);
  }
}
